function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Box from '../../Box';

var Header = function Header(props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "header",
    ta: "center",
    color: "text.primary",
    fw: "medium",
    fs: "xlarge",
    mb: "large"
  }, props));
};

Header.displayName = 'Dialog.Header';
export default Header;